export default "__VITE_ASSET__50f8f2b8__"